module.exports = __webpack_public_path__ + "img/iguana-tatuada-1210.054f948c.webp";